<template>
    <div class="wrap">
        <div class="content">
            <base-header :name="user_name" :topOnly="flag_top" :account_list="account_list"></base-header>
            <!-- 购买 -->
            <div class="buy-part">
                <div class="half" v-if="first_buy"></div>
                <div class="title">
                    <p style="display: block;margin-bottom:.15rem">
                        我的积分：
                        <em>{{score_amount}}</em>我的元宝：
                        <em>{{gold_amount}}</em>
                    </p>
                    <p @click="pop_log_type=1;getMyLog();pop_show=1;">
                        <span>购买记录</span>
                    </p>
                    <p @mouseenter="en_show" @mouseleave="le_hide">
                        <span>奖品说明</span>
                    </p>
                    <!-- <p @click="pop_log_type=4;getMyLog();pop_show=7;">
                        <span>红包记录</span>
                    </p> -->
                </div>
                <ul class="buy-ul">
                    <li :class="'buy-li '+ 'buy-li-'+ index" v-for="(item,index) in lucky_list" :key="index">
                        <div class="message">
                            <p class="info">
                                每<em>{{item.total}}</em>个订单中随机一名<br>
                                <span @click="getAllLogs(item.id, 0); pop_show=5; ">幸运玩家</span>
                                获得<em>{{item.gold}}</em>元宝
                            </p>
                        </div>
                        <div class="toy" @mouseenter="showTips(item, index, true)" @mouseleave="showTips(item, index, false)"></div>
                        <p class="info2">{{Number(item.num) % item.total}}/{{item.total}}</p>
                        <p class="price">{{item.price}}酒币/1个</p>
                        <div class="btns">
                            <div class="btn buy1" @click="raffle(1, item.id,index)"></div>
                            <div class="btn buy4" @click="raffle(4, item.id,index)"></div>
                        </div>

                        <!-- 悬浮框 -->
                        <div :class="'popup' + (index==0?' first-one':'')" v-show="item.show_tips">
                            <p class="tite">{{item.title}}</p>
                            <div class="box">
                                <div style="padding: .26rem 0 .17rem 0">
                                    <p>以下道具获得概率均为20%{{'（可回收为'+(index==0?10:index==1?20:50)+'积分）'}}</p>
                                </div>
                                <div class="imgs">
                                    <div class="img" v-for="(each,i) in item.items" :key="i">
                                        <img :src="'https://cdn.09game.com/resources/item/dj_'+ each.id +'_200.png'" alt />
                                        <div class="table">
                                            <p>{{each.name}}</p>
                                        </div>
                                    </div>
                                </div>
                                <p style=" margin: .5rem 0 .1rem 0">每{{item.total}}个订单中随机一名幸运玩家获得{{item.gold}}元宝</p>
                                <p class="red">元宝可兑换实体大奖</p>
                            </div>
                        </div>

                        <!--送积分进度条-->
                        <div :class="'gold-box-top gold-'+index" v-show="jf_list.length > 0 && jf_list[index].showEngry">
                            <div class="show-tip">
                                <div class="tips">
                                    <p>积分能量条：</p>
                                    <p>1.每购买1个礼盒增加1点能量</p>
                                    <p>2.可直接领取对应积分奖励</p>
                                    <p>3.礼包售罄后，能量条将被清空（11月25日18点截止购买）</p>
                                    <p>4.活动期间购买礼盒次数达到5、15、30次可领取</p>
                                </div>
                            </div>
                            <div class="progress">
                                <div class="val" :style="{'width': item.jy_progress}"></div>
                            </div>
                            <div class="num" v-if="!(jf_list.length > 0 && jf_list[index].status == 'get')">{{ item.jf_energy }}/{{ jf_list.length > 0 ? item.jf_total * jf_list[index].addNum : 5 }}</div>
                            <div :class="'btn '+ (jf_list.length>0 ? jf_list[index].status : '')" v-else @click="saveEnergy2(item, index)"></div>
                        </div>

                        <!-- 送元宝进度条 -->
                        <div :class="'gold-box gold-'+index">
                            <div class="show-tip">
                                <div class="tips">
                                    <p>福利元宝能量条：</p>
                                    <p>1.每购买1个礼盒增加1点能量</p>
                                    <p>2..等待当前批次结算：</p>
                                    <p>- 您是本批次幸运玩家，能量条清空一轮（超过部分不会清除）</p>
                                    <p>- 您不是本批次幸运玩家，满能量则可直接领取一次对应礼盒的元宝奖励，同时能量条清空一轮（超过部分不会清除）</p>
                                    <p>3.礼包售罄后，能量条将被清空（11月25日18点截止购买）</p>
                                </div>
                            </div>
                            <div class="progress">
                                <div class="val" :style="{'width': item.progress}"></div>
                            </div>
                            <div class="num" v-if="!(fd_list.length > 0 && fd_list[index].status == 'get')">{{item.energy}}/{{item.en_total}}</div>
                            <div :class="'btn '+ (fd_list.length>0 ? fd_list[index].status : '')" v-else @click="saveEnergy(item, index)"></div>
                        </div>
                        <div class="recent" style="height:40px;">
                            <p v-if="item.recent_name">
                                恭喜
                                <em @click="getAllLogs(item.id, 0); pop_show=5;">{{item.recent_name}}</em>！
                            </p>
                            <p v-if="item.recent_name">
                                在&nbsp;
                                <span @click="getAllLogs(item.id, 0); pop_show=5;">{{item.recent_order}}</span>
                                批次中获得{{item.gold}}元宝
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 活动说明 -->
            <div class="explain">
                <div class="qa_list">
                    <div class="qa" v-for="(i,d) in qa_list" :key="d">
                        <p class="q">{{i}}</p>
                    </div>
                </div>
            </div>

            <div class="mate-info"></div>
            <div class="mate-info2">
                <p>
                    <span>1、冬季体验盒（购买后随机获得以下1款奖励）：</span>1288酒豆 （有效期7天）
                    <br />成就达人卡*2天
                    <br />5个重转符文石（有效期永久）
                    <br />220赛季功勋
                    <br />5个DS大随宝箱钥匙（有效期永久）
                    <br />
                    <em>每130个订单中随机产生一名幸运玩家</em>
                </p>
                <p>
                    <span>2、火热冲分盒（购买后随机获得以下1款奖励）：</span>双倍积分卡*4
                    <br />100%赦免卡*1张
                    <br />单人挑战卡*10张
                    <br />10个重转符文石（有效期永久）
                    <br />10个DS大随宝箱钥匙（有效期永久）
                    <br />
                    <em>每260个订单中随机产生一名幸运玩家</em>
                </p>
                <p>
                    <span>3、激情畅玩盒（购买后随机获得以下1款奖励）：</span>6500酒豆（有效期7天）
                    <br />成就达人卡*10天
                    <br />25个重转符文石（有效期永久）
                    <br />1200赛季功勋
                    <br />25个DS大随宝箱钥匙（有效期永久）
                    <br />
                    <em>每390个订单中随机产生一名幸运玩家</em>
                </p>
            </div>
        </div>
        <div class="mark" v-if="pop_show||animate||popup_show||dialog_show"></div>

        <div :class="'pop '+(pop_show==1||pop_show==5||pop_show==7?'log':
					pop_show==3?'picpreview':
					pop_show==6?'first':'preview')" v-if="pop_show">
            <div class="close" @click="closePop()"></div>
            <!-- 获取记录 -->
            <div v-if="pop_show==1">
                <div class="tite">我的记录</div>
                <div class="inner">
                    <div class="title-box">
                        <div :class="`left ${pop_log_type==1?'active':''}`" @click="pop_log_type=1; getMyLog();">购买记录</div>
                        <div :class="`right ${pop_log_type==2?'active':''}`" @click="pop_log_type=2; getMyLog();">元宝获得记录</div>
                        <div :class="`right ${pop_log_type==3?'active':''}`" @click="pop_log_type=3; getMyLog();">礼品兑换记录</div>
                    </div>
                    <div class="table-title">
                        <div class="time">{{pop_log_type==1?'时间/批次':pop_log_type==2?'批次':'兑换时间'}}</div>
                        <div class="goods">物品</div>
                        <div class="status">状态</div>
                    </div>
                    <div class="pop-scroll" v-if="log_list.length">
                        <div v-for="(item, index) in log_list" :key="index">
                            <!-- 购买记录 -->
                            <div v-if="pop_log_type==1" class="content-li">
                                <p>
                                    {{item.create_time.replace(/\T/g, ' ').slice(5)}}
                                    <span class="link" @click="dialog_show=3; getAllLogs(item.scene.substring(0,1), 1, item.scene)">{{item.scene}}</span>
                                </p>
                                <p>{{item.item_name+ (item.gift_name?('（'+item.gift_name+'）'):'')}}</p>
                                <p>{{item.add_flag==1?('回收为：'+item.add_count+'积分'):'已放入背包'}}</p>
                            </div>
                            <!-- 元宝获得记录 -->
                            <div v-else-if="pop_log_type==2" class="content-li">
                                <p v-if="item.scene=='元宝能量条'">
                                    {{item.create_time.replace(/\T/g, ' ').slice(5)}}
                                    <span>{{item.scene}}</span>
                                </p>
                                <p v-else>
                                    {{item.create_time.replace(/\T/g, ' ').slice(5)}}
                                    <span class="link" @click="dialog_show=3; getAllLogs(item.scene.substring(0,1), 1, item.scene)">{{item.scene}}</span>
                                </p>
                                <p>{{item.item_name+ (item.gift_name?('（'+item.gift_name+'）'):'')}}</p>
                                <p>已放入背包</p>
                            </div>
                            <!-- 礼品兑换记录 -->
                            <div v-else-if="pop_log_type==3" class="content-li">
                                <p>{{item.create_time.replace(/\T/g, ' ')}}</p>
                                <p :title="item.packet_name">{{item.packet_name}}</p>
                                <p v-if="item.packet_id==908612">已放入背包</p>
                                <p v-else-if="item.packet_id==908605" class="link" @click="getMyKami(item.log_id); popup_show = 3;">查看详情</p>
                                <p v-else class="link" @click="getDetails(item.log_id); dialog_show = 2;">查看详情</p>
                            </div>
                        </div>
                    </div>
                    <div class="kong" v-else style="width: 100%;height:2rem;line-height:2rem;text-align: center;color:#ffffff;font-weight: bold;font-size: .22rem;">暂无数据</div>
                </div>
            </div>
            <!-- 视频预览 -->
            <div v-else-if="pop_show==2">
                <div class="tite">{{video_name}}</div>
                <div class="video" style="width: 480px;height:240px;margin:0 auto;">
                    <video :src="`https://cdn.09game.com/resources/flv/${video_url}.mp4`" style="display: block;width: 480px;height:240px;margin:0 auto;" v-if="video_url" autoplay loop></video>
                </div>
            </div>
            <!-- 大图预览 -->
            <div v-else-if="pop_show==3">
                <div class="tite">{{pic_name}}</div>
                <div class="video" style="width: 480px;height: 240px;margin:10px auto;">
                    <img :src="`https://cdn.09game.com/resources/item/${pic_url}.png`" alt style="width: 480px; height: auto;margin: 0 auto;display: block;" />
                </div>
            </div>
            <!-- 最近10批幸运玩家名单 -->
            <div v-else-if="pop_show==5">
                <div class="tite">最近10批幸运玩家名单</div>
                <div class="inner">
                    <div class="title-box">
                        <div :class="`left ${recent_type=='A'?'active':''}`" @click="recent_type='A'; getAllLogs('A',0)">体验礼盒</div>
                        <div :class="`right ${recent_type=='B'?'active':''}`" @click="recent_type='B'; getAllLogs('B',0)">冲分礼盒</div>
                        <div :class="`left ${recent_type=='C'?'active':''}`" @click="recent_type='C'; getAllLogs('C',0)">畅玩礼盒</div>
                    </div>
                    <div class="table-title">
                        <div class="time">订单批次</div>
                        <div class="goods">时间</div>
                        <div class="status">幸运玩家昵称</div>
                    </div>
                    <div class="pop-scroll" v-if="batch_list.length">
                        <div v-for="(item, index) in batch_list" class="content-li" :key="index">
                            <p @click="dialog_show=3; getAllLogs(recent_type, 1, item.scene);" class="link">{{item.scene}}</p>
                            <p>{{item.create_time.replace(/\-/g, '/').replace(/\T/g, ' ').slice(5)}}</p>
                            <p>{{item.user_name}}</p>
                        </div>
                    </div>
                    <div class="kong" v-else style="width: 100%;height:2rem;line-height:2rem;text-align: center;color:#ffffff;font-weight: bold;font-size: .22rem;">暂无数据</div>
                </div>
            </div>
            <!-- 初次购买提示框 -->
            <div v-else-if="pop_show==6">
                <p v-if="open_page && first_buy">
                    享受首次购买半价：
                    <span style="color: #FF0000">{{buy_type=='A'?49:buy_type=='B'?99:249}}酒币/1次</span>
                </p>
                <p>
                    是否消耗：
                    <span>{{Number(buy_type=='A'?99:buy_type=='B'?199:499)* times - (open_page && first_buy?(buy_type=='A'?50:buy_type=='B'?100:250):0)}}酒币</span>
                    购买{{times+"个"+(buy_type=='A'?'冬季体验盒':buy_type=='B'?'火热冲分盒':'激情畅玩盒')}}？
                </p>
                <div class="btns">
                    <div class="btn" @click="raffle_run(times, buy_type)"></div>
                    <div class="btn" @click="pop_show = 0"></div>
                </div>
            </div>
            <!-- 红包记录 -->
            <div v-else-if="pop_show==7">
                <div class="tite">红包记录</div>
                <div class="inner">
                    <div class="table-title">
                        <div class="time">时间</div>
                        <div class="goods">红包</div>
                        <div class="status">数量</div>
                    </div>
                    <div class="pop-scroll" v-if="log_list.length">
                        <div v-for="(item, index) in log_list" class="content-li" :key="index">
                            <p>{{item.create_time.replace(/\-/g, '/').replace(/\T/g, ' ').slice(5)}}</p>
                            <p @click="dialog_show=6; getAllLogs(item.scene.substring(0,1), 2, item.scene, item.envelope_name);" class="link">{{'"'+item.envelope_name+'"'}}</p>
                            <p>{{"获得："+item.amount+""+item.item_name}}</p>
                        </div>
                    </div>
                    <div class="kong" v-else style="width: 100%;height:2rem;line-height:2rem;text-align: center;color:#ffffff;font-weight: bold;font-size: .22rem;">暂无数据</div>
                </div>
            </div>
        </div>

        <div :class="'pop pop2 '+(popup_show==2?'log':popup_show==3?'pop-card':'')" v-if="popup_show">
            <div class="close" v-if="popup_show==3" @click="popup_show = 0; showEyes= true;"></div>
            <div class="close" v-else @click="closePop2()"></div>

            <!-- 卡密 -->
            <div v-if="popup_show==3">
                <div class="title">200元 京东卡</div>
                <div class="box">
                    <p class="name">200元 京东卡</p>
                    <p class="miss">卡密：{{showEyes? '**********************' : kami}}</p>
                    <div class="eyes" @click="showEyes = !showEyes"></div>
                    <p class="info">注：京东卡密一旦泄密造成的损失概不负责，请务必保管好自己的账号隐私。</p>
                </div>
            </div>
        </div>

        <div :class="'pop pop3 '+(dialog_show==2?'show-add':
				dialog_show==3||dialog_show==6?'pici':'')" v-if="dialog_show">
            <div class="close" v-if="dialog_show==3||dialog_show==6" @click="dialog_show = 0;"></div>
            <div class="close" v-else @click="closePop3()"></div>

            <!-- 联系客服 -->
            <div v-if="dialog_show==2">
                <div class="tite">收货信息</div>
                <div class="box">
                    <div class="inner-box">
                        <p><span>收货人：</span>{{detailInfo.name}}</p>
                        <p><span>手机号：</span>{{detailInfo.mobile}}</p>
                        <p><span>收货地址：</span>{{detailInfo.address}}</p>
                        <p><span>联系QQ：</span>{{detailInfo.qq}}</p>
                    </div>
                    <div class="btn get" @click="dialog_show = 0;"></div>
                </div>
            </div>

            <!-- 获取记录 -->
            <div v-if="dialog_show==3">
                <div class="tite">{{mart_code+'-批次详情'}}</div>
                <ul class="info">
                    <li>时间</li>
                    <li style="padding-right: .4rem;">参与玩家</li>
                </ul>
                <ul class="box">
                    <li class="line" v-for="(item,index) in detail_list" :key="index">
                        <p :class="{'lucky-name': item.kit_flag}">{{item.create_time.replace(/\-/g, '/').replace(/\T/g, ' ').slice(5)}}</p>
                        <p :class="{'lucky-name': item.kit_flag}" style="padding-right: .2rem;">{{item.user_name}}</p>
                        <div class="lucky" v-if="item.kit_flag"></div>
                    </li>
                </ul>
            </div>

            <!-- 红包前五名 -->
            <div v-if="dialog_show==6">
                <div class="tite">{{"“"+mart_code+'”领取前五名'}}</div>
                <ul class="info">
                    <li>时间</li>
                    <li>参与玩家</li>
                    <li>数量</li>
                </ul>
                <ul class="box">
                    <li class="line" v-for="(item,index) in detail_list" :key="index">
                        <p>{{item.create_time.replace(/\-/g, '/').replace(/\T/g, ' ').slice(5)}}</p>
                        <p>{{item.user_name}}</p>
                        <p>获得：{{item.amount}}酒豆</p>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 恭喜获得弹框 -->
        <div class="luck-box" v-if="animate && result_list.length>0">
            <div class="close" @click="animate= false; result_list=[]; "></div>
            <div class="title">恭喜获得</div>
            <p class="toast">{{(buy_type=='A'?'可回收为10积分':buy_type=='B'?'可回收为20积分':'可回收为50积分')}}</p>
            <ul class="luck-ul">
                <li :class="'luck-li luck-li-'+ index" v-for="(item, index) in result_list" :key="index">
                    <div class="name">{{item.item_name}}</div>
                    <div class="img">
                        <img :src="`https://cdn.09game.com/resources/item/dj_${item.item_id}_200.png`" alt />
                    </div>
                    <div :class="'recycle'+ (item.rec_msg?' recycled':'')" @click="recycleScore(item, index)">{{item.rec_msg?item.rec_msg: '回收积分'}}</div>
                </li>
            </ul>
            <div class="btn" @click="animate= false; result_list=[]; "></div>
        </div>
    </div>
</template>
<script>
import { isToday, setEndTime } from '@/utils/common'
import { baseUrls } from '@/utils/baseUrlConfig'
const user_url = baseUrls.user_url
var now = new Date().setHours(0, 0, 1, 0)
var today = new Date(now).getDay()
today = today == 0 ? 7 : today

var timer = null
var timer2 = null
var hd_url = 'https://hd.09game.com/2024draw/'
var tn_url = 'https://hd.09game.com/redenvelope/'
const shop_url = baseUrls.shop_url
const base_url = baseUrls.user_url

var mouse,
    _09game = null

export default {
    name: 'winter_lottery',
    data() {
        return {
            token: this.$storage.getToken(),
            isActive: false,
            user_name: '',
            account_list: [],
            flag_top: true,
            payData: {},
            pay_jiubi: 0,
            progress: 0,
            tab: 1,
            nowTime: new Date(),
            app_id: 90860, //活动ID
            score_id: 20110, //积分ID
            score_amount: 0, // 拥有积分数量
            gold_id: 20127, //元宝id
            gold_amount: 0, //元宝数量
            exchange_list: [], // 兑换列表
            result_list: [], // 中奖结果列表
            btn_lock: false, // 按钮是否可点
            timer: null, // 定时器
            timer2: null, // 定时器
            times: 0, // 抽奖次数
            animate: false, // 是否展示获奖弹框
            pop_show: 0, //  // 0 不显示 1 获奖记录 2 视频展示 3 奖品大图  5 最近10批幸运玩家名单 6.初次购买提示框7.红包记录
            popup_show: 0, //0.不显示 1.兑换2选1  3.卡密
            dialog_show: 0, ///购买弹框不显示1.填写收货信息2.联系客服3.获取记录4.提交成功5.抢到酒豆提示6. 红包前五名
            video_url: '', // 道具预览视频链接
            video_name: '',
            pic_url: '',
            pic_name: '',
            pop_log_type: 1, // 1 抽奖记录 2 兑换记录
            recent_type: null, //最近10批类型
            log_list: [], // 我的历史记录
            top_message: [],
            qa_list: [
                'a）本次活动中产生的 元宝+积分能量条/积分/元宝 会在活动结束后统一清空，请及时使用；',
                'b）京东卡兑换后，可在礼品记录中查看卡密；一旦泄密造成的损失概不负责，请务必保管好自己的账号隐私。',
                'c）获赠实体礼品，将在活动结束后15个工作日内发放（除特殊缺货情况外）。',
                'd）除偏远地区外（新疆，西藏，内蒙古，青海及香港澳门台湾地区），礼品包邮配送，具体可联系在线客服咨询。',
            ],
            lucky_list: [
                {
                    id: 'A',
                    name: '冬季体验盒',
                    recent_name: '',
                    recent_order: '',
                    total: 130,
                    gold: 200,
                    price: 99,
                    en_total: 100,
                    jf_total: 5,
                    num: 0,
                    jf_energy: 0,
                    energy: 0,
                    title: '冬季体验盒',
                    items: [
                        {
                            id: 0,
                            name: '1288酒豆（有效期7天）',
                        },
                        {
                            id: 26,
                            name: '成就达人卡*2天',
                        },
                        {
                            id: 19804,
                            name: '5个重转符文石（有效期永久）',
                        },
                        {
                            id: 20053,
                            name: '220赛季功勋',
                        },
                        {
                            id: 2639004,
                            name: '5个DS大随宝箱钥匙（有效期永久）',
                        },
                    ],
                },
                {
                    id: 'B',
                    name: '火热冲分盒',
                    recent_name: '',
                    recent_order: '',
                    total: 260,
                    gold: 800,
                    price: 199,
                    en_total: 200,
                    jf_total: 5,
                    num: 0,
                    energy: 0,
                    title: '火热冲分盒',
                    items: [
                        {
                            id: 19,
                            name: '双倍积分卡*4',
                        },
                        {
                            id: 18,
                            name: '100%失败赦免卡*1张',
                        },
                        {
                            id: 28,
                            name: '单人挑战卡*10张',
                        },
                        {
                            id: 19804,
                            name: '10个重转符文石（有效期永久）',
                        },
                        {
                            id: 2639004,
                            name: '10个DS大随宝箱钥匙（有效期永久）',
                        },
                    ],
                },
                {
                    id: 'C',
                    name: '激情畅玩盒',
                    recent_name: '',
                    recent_order: '',
                    total: 390,
                    gold: 3000,
                    price: 499,
                    en_total: 300,
                    jf_total: 5,
                    num: 0,
                    energy: 0,
                    title: '激情畅玩盒',
                    items: [
                        {
                            id: 0,
                            name: '6500酒豆（有效期7天）',
                        },
                        {
                            id: 26,
                            name: '成就达人卡*10天',
                        },
                        {
                            id: 19804,
                            name: '25个重转符文石（有效期永久）',
                        },
                        {
                            id: 20053,
                            name: '1200赛季功勋	',
                        },
                        {
                            id: 2639004,
                            name: '25个DS大随宝箱钥匙（有效期永久）',
                        },
                    ],
                },
            ],
            award_list: [
                {
                    id: 0,
                    packet_id: 908612,
                    count: 100,
                    name: '100积分',
                    type: -1,
                    name1: '100积分',
                },
                {
                    id: 1,
                    packet_id: 908605,
                    count: 200,
                    name: '200元京东卡',
                    type: -1,
                    name1: '200元京东卡',
                },
                {
                    id: 2,
                    packet_id: 908606,
                    count: 1200,
                    name: 'Apple/苹果 AirPods 4(支持主动降噪)',
                    type: -1,
                    name1: 'Apple/苹果 AirPods 4',
                },
                {
                    id: 3,
                    packet_id: 908607,
                    count: 4800,
                    name: '小米15手机(16GB+512GB)',
                    type: -1,
                    name1: '小米15手机',
                },
                {
                    id: 4,
                    packet_id: 908608,
                    count: 8100,
                    name: 'Apple/苹果 iphone16 pro(256G原色)',
                    type: -1,
                    name1: 'Apple/苹果 iphone16 pro',
                },
            ], //实物大奖列表
            batch_list: [], //最近10批次幸运玩家列表
            detail_list: [], //某个批次详情信息
            buy_type: null, // A数码宝贝，B龙珠，C汽车人
            head: 0, //头像
            choose_id: 0, // 选择的id
            choose_info: null,
            choose_index: -1,
            packet: {}, //选择的礼包
            cfg_packet: [], //活动礼包列表
            real_name: '',
            qq_number: '',
            mobile: '',
            address: '',
            mart_code: '', //查看的批次单号
            choose_scene: '', //选择的单号
            kami: '', //我的卡密
            showEyes: true, //是否显示眼睛
            fd_list: [], //能量礼包
            jf_list: [], //积分能量礼包
            detailInfo: {},
            first_buy: true,
            open_page: true,
            red_info: [], //红包信息
            timerSecondA: null,
            timerSecondB: null,
            timerSecondC: null,
            timer_showtips: null,
            firstScoreToGold: true,
            buyUrl: '',
            buyBoxIndex: '',
            diffWithServer: '',
        }
    },
    mounted() {
        document.addEventListener('scroll', this.downFunc)
    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.downFunc)
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (vm.$common.checkToken(vm.token)) {
                vm.$http.set_anchor(13, vm.token)
            }
        })
    },
    created() {
        // setEndTime('2024-11-25 23:59:59')
        this.requireToken()
    },
    methods: {
        downFunc() {
            const scrollTop = document.documentElement.scrollTop + document.body.scrollTop
            if (scrollTop >= 160) {
                this.isActive = true
            } else {
                this.isActive = false
            }
        },
        requireToken() {
            var Ucookie = this.token
            if (Ucookie != null) {
                var now = new Date().getTime()
                if (now >= Ucookie.split('-')[3] * 1000) {
                    //token过期
                    this.get_auth()
                } else {
                    this.init()
                }
            } else {
                this.get_auth()
            }
        },
        get_auth() {
            window.location.replace(base_url + '/GetWxOpenid?fromPage=winter_lottery')
        },
        init() {
            Object.assign(this.$data, this.$options.data.call(this))
            this.token = this.$storage.getToken()
            this.user_id = this.token.split('-')[0]
            var nowDate = new Date()
            this.gold_amount = this.query_my_item(this.gold_id)
            this.query_time()
            this.query_user_baseInfo()
            this.getRecentLucky()

            Promise.all([this.query_app(), this.getFirstBuy()]).then((res) => {
                let [res1, res2] = res
                Promise.all([this.query_my_packet()]).then((result) => {
                    this.getCounts()
                })
            })
            this.score_amount = this.query_my_item(this.score_id);
        },
        // 显示对应礼盒礼品
        showTips(item, index, flag) {
            let _this = this
            if (flag) {
                _this.timer_showtips = setTimeout(function () {
                    item.show_tips = flag
                    _this.$set(_this.lucky_list, index, item)
                }, 500)
            } else {
                clearTimeout(_this.timer_showtips)
                item.show_tips = flag
                _this.$set(_this.lucky_list, index, item)
            }
        },

        query_time() {
            $.ajax({
                url: 'https://webapi.09game.com/Home/GetDateNow',
                async: false,
                success: (res) => {
                    if (res.code == 0) {
                        let now = res.msg.toString().replace(/-/g, '/')
                        this.nowTime = new Date(now)
                        this.diffWithServer = new Date(now).getTime() - new Date().getTime() //与服务器之间的时间差值
                    } else {
                        this.nowTime = new Date()
                        this.diffWithServer = 0
                    }
                },
            })
        },

        // 点击回收积分
        recycleScore(item, index) {
            let _this = this
            let element = '.luck-li-' + index
            if (this.btn_lock) {
                return false
            }
            if (item.rec_msg) {
                return
            }
            _this.btn_lock = true

            let data = {
                token: this.token,
                type: _this.buy_type,
                item_id: item.item_id,
                log_id: item.log_id,
            }
            this.$http.q_hd('GetDraw', hd_url, data).then((res) => {
                if (res.code == 0) {
                    item.rec_msg = res.msg
                    // _this.mate_show(element, res.msg, 50);
                    _this.btn_lock = false
                    _this.getCounts()
                    _this.score_amount = _this.query_my_item(_this.score_id)
                    _this.$set(_this.result_list, index, item)
                } else {
                    _this.mate_show(element, res.error, 50)
                    _this.btn_lock = false
                }
            })
        },
        //获取我的卡密
        getMyKami(id) {
            let _this = this
            let data = {
                token: this.token,
                log_id: id,
            }
            this.$http.q_hd('KaMi', hd_url, data).then((res) => {
                if (res.code == 0) {
                    _this.kami = res.msg
                } else {
                    _this.kami = ''
                }
            })
        },

        //获取我的历史记录
        getMyLog() {
            //type 1 查购买记录 2 元宝获得记录 3 礼品兑换记录 4 红包记录
            let _this = this
            let element = '.buy-ul'
            let type = _this.pop_log_type
            let data = {
                token: this.token,
                type: type,
            }
            this.$http.q_hd('GetKit', hd_url, data).then((res) => {
                if (res.code == 0) {
                    _this.log_list = res.msg
                } else {
                    _this.log_list = []
                }
            })
        },
        getFirstBuy() {
            //type 1 查购买记录 2 元宝获得记录 3 礼品兑换记录 4 红包记录
            let _this = this
            let data = {
                token: this.token,
                type: 1,
            }
            return this.$http.q_hd('GetKit', hd_url, data).then((res) => {
                if (res.code == 0) {
                    let timeC = ''
                    if (res.msg && res.msg.length > 0) {
                        for (let item of res.msg) {
                            timeC = item.create_time.replace(/\T/g, ' ')
                            if (isToday(timeC)) {
                                _this.first_buy = false
                                _this.buy_type = 'B'
                                break
                            }
                        }
                    } else {
                        _this.first_buy = true
                    }
                } else {
                    _this.first_buy = true
                }
            })
        },
        async getDefaultMyLog() {
            //type 1 查购买记录 2 元宝获得记录 3 礼品兑换记录 4 红包记录
            let _this = this
            let element = '.buy-ul'
            let data = {
                token: this.token,
                type: 2,
            }
            await this.$http.q_hd('GetKit', hd_url, data).then((res) => {
                if (res.code == 0) {
                    // _this.log_list = res.msg;
                    if (res.msg && res.msg.length > 0) {
                        if (res.msg.filter((rr) => rr.kit_status == 0).length > 0) {
                            _this.pop_log_type = 2
                        }
                    }
                } else {
                    // _this.log_list = [];
                }
            })
        },

        //获取订单数
        async getCounts() {
            //type
            let _this = this
            let type = _this.pop_log_type

            for (let i = 0; i < _this.lucky_list.length; i++) {
                let item = _this.lucky_list[i]
                let data = {
                    type: item.id,
                    token: this.token,
                }
                await this.$http.q_hd('GetCounts', hd_url, data).then((res) => {
                    if (res.code == 0) {
                        item.num = res.count
                        item.jf_energy = res.pay_count
                        item.energy = res.status
                    } else {
                        item.num = 0
                        item.jf_energy = 0
                        item.energy = 0
                    }
                    item.progress = ((item.energy / item.en_total) * 100 > 100 ? 100 : (item.energy / item.en_total) * 100) + '%'
                    let total = _this.jf_list.length > 0 ? item.jf_total * _this.jf_list[i].addNum : item.jf_total
                    item.jy_progress = ((item.jf_energy / total) * 100 > 100 ? 100 : (item.jf_energy / total) * 100) + '%'
                    _this.$set(_this.lucky_list, i, item)
                })
            }

            await _this.query_my_packet()
        },

        //获取订单记录
        getAllLogs(type, status, code, name) {
            //status 0最近10批幸运玩家 1某个批号的所有订单 3上一轮幸运玩家的昵称 2红包领取前五名
            let _this = this
            let data = {
                type: type,
                status: status,
                mart_code: code,
            }
            this.$http.q_hd('GetLogS', hd_url, data).then((res) => {
                if (status == 0) {
                    if (res.code == 0) {
                        _this.recent_type = type
                        _this.batch_list = res.msg
                    } else {
                        _this.batch_list = []
                    }
                } else {
                    if (res.code == 0) {
                        _this.mart_code = status == 2 ? name : code
                        _this.detail_list = res.msg
                    } else {
                        _this.mart_code = ''
                        _this.detail_list = []
                    }
                }
            })
        },

        //获取幸运玩家信息
        getRecentLucky() {
            //status 0最近10批幸运玩家 1某个批号的所有订单 3上一轮幸运玩家的昵称 2红包领取前五名
            let _this = this
            for (let i = 0; i < _this.lucky_list.length; i++) {
                let item = _this.lucky_list[i]
                let data = {
                    type: item.id,
                    status: 3,
                }
                this.$http.q_hd('GetLogS', hd_url, data).then((res) => {
                    if (res.code == 0) {
                        item.recent_name = res.user_name
                        item.recent_order = res.msg
                    } else {
                        item.recent_name = ''
                        item.recent_order = ''
                    }
                    _this.$set(_this.lucky_list, i, item)
                })
            }
        },

        //获取订单详情信息
        getDetails(id) {
            let _this = this
            let data = {
                token: this.token,
                log_id: id,
            }
            this.$http.q_hd('GetUser', hd_url, data).then((res) => {
                if (res.code == 0 && res.msg) {
                    _this.detailInfo = res.msg
                } else {
                    _this.detailInfo = null
                }
            })
        },

        get_user_info() {
            let _this = this
            $.ajax({
                url: 'https://users.09game.com/Home/GetUserInfo',
                data: {
                    token: this.token,
                },
                success(res) {
                    if (res.result == 0) {
                        _this.head = res.temp.avtar_head
                    }
                },
            })
        },

        query_app() {
            var _this = this
            var tasks = []
            _this.cfg_packet = []
            _this.fd_list = []
            return this.$http.q_cfg_packet(this.app_id).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        item.status = ''
                        item.items = []
                        for (var i = 1; i <= 6; i++) {
                            var obj = item['gift' + i + '_setting']
                            if (obj) {
                                item.items.push(JSON.parse(obj))
                            }
                        }

                        _this.cfg_packet.push(item)
                        if (item.packet_id >= 908609 && item.packet_id <= 908611) {
                            _this.fd_list.push(item)
                        }

                        if (item.packet_id >= 908613 && item.packet_id <= 908615) {
                            _this.jf_list.push(item)
                        }
                    }
                }

                _this.initPage()
            })
        },
        // 更新对应礼盒的礼包
        query_my_packet() {
            var _this = this
            return this.$http.q_my_packet(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        for (var day of _this.fd_list) {
                            if (day.packet_id == item.packet_id) {
                                day.packet = item
                            }
                        }

                        for (var day of _this.jf_list) {
                            if (day.packet_id == item.packet_id) {
                                day.packet = item
                            }
                        }
                    }
                }

                _this.initPage()
            })
        },
        // 更新对应礼盒的按钮状态
        initPage() {
            for (var day of this.fd_list) {
                var packet = day.packet
                if (packet) {
                    if (packet.balance > 0 && packet.expire_days > 0) {
                        day.status = 'get'
                    } else if (packet.balance == 0 && packet.expire_days > 0) {
                        day.status = 'over'
                    } else {
                        day.status = ''
                    }
                } else {
                    day.status = ''
                }
            }

            for (var day of this.jf_list) {
                var packet = day.packet
                if (packet) {
                    if (packet.balance > 0 && packet.expire_days > 0) {
                        day.status = 'get'
                    } else if (packet.balance == 0 && packet.expire_days > 0) {
                        day.status = 'over'
                    } else {
                        day.status = ''
                    }
                } else {
                    day.status = ''
                }
            }

            // 判断积分能量显示、积分能量总值
            this.jf_list.map((item) => {
                item.showEngry = true
                item.addNum = 1
                if (item.packet) {
                    let packet = item.packet
                    packet.sub_count >= 3 && item.status == 'over' ? (item.showEngry = false) : (item.showEngry = true)
                    packet.sub_count == 1 ? (item.addNum = 3) : packet.sub_count == 2 ? (item.addNum = 6) : (item.addNum = 1)
                }
            })
        },
        // 领取对应礼盒的礼包
        saveEnergy(i, d) {
            var _this = this
            if (_this.fd_list[d].status != 'get') {
                return false
            }
            if (_this.btn_lock) {
                return false
            }

            var element = '.gold-' + d + ' .btn'

            var text = ''
            _this.btn_lock = true
            $.ajax({
                url:
                    shop_url +
                    JSON.stringify({
                        type: 'use_packet',
                        json: JSON.stringify({
                            packet_id: _this.fd_list[d].packet_id,
                            TOKEN: this.token,
                        }),
                    }),
                success: function (res) {
                    if (res.code == 0) {
                        text = '元宝领取成功'
                        _this.query_my_packet()
                        _this.gold_amount = _this.query_my_item(_this.gold_id)
                    } else {
                        text = res.info ? res.info : '领取失败'
                    }
                    _this.btn_lock = false
                    _this.mate_show(element, text, -40)
                },
            })
        },
        // 领取对应礼盒的礼包
        saveEnergy2(i, d) {
            var _this = this
            if (_this.jf_list[d].status != 'get') {
                return false
            }
            if (_this.btn_lock) {
                return false
            }

            var element = '.gold-' + d + ' .btn'
            var text = ''
            _this.btn_lock = true
            $.ajax({
                url:
                    shop_url +
                    JSON.stringify({
                        type: 'use_packet',
                        json: JSON.stringify({
                            packet_id: _this.jf_list[d].packet_id,
                            TOKEN: this.token,
                        }),
                    }),
                success: function (res) {
                    if (res.code == 0) {
                        text = '积分领取成功！'
                        Promise.all([_this.query_my_packet()]).then((result) => {
                            _this.getCounts()
                        })
                        _this.score_amount = _this.query_my_item(_this.score_id)
                    } else {
                        text = res.info ? res.info : '领取失败'
                    }
                    _this.btn_lock = false
                    _this.mate_show(element, text, -30)
                },
            })
        },

        chooId(i, d) {
            this.choose_info.type = i
        },

        query_my_item(id) {
            var _this = this
            var amount = 0
            $.ajax({
                url:
                    'https://shop.09game.com/shop?' +
                    JSON.stringify({
                        type: 'q_my_item',
                        json: JSON.stringify({
                            item_id: id,
                            token: this.token,
                        }),
                    }),
                async: false,
                success: (res) => {
                    if (res.code == 0) {
                        amount = res.records[0].amount
                    }
                },
            })
            return amount
        },

        raffle(times, type, index) {
            // 抽奖
            this.buyBoxIndex = index
            if (times) {
                this.times = times
            }

            if (type) {
                this.buy_type = type
            }
            if (this.times == 0) {
                return false
            }
            if (this.btn_lock) {
                return false
            }
            this.animate = false

            if (this.open_page) {
                this.pop_show = 6
                return
            }

            this.raffle_run(this.times, this.buy_type)
        },
        raffle_run(times, type) {
            let _this = this
            if (timer != null) {
                clearTimeout(timer)
                timer = null
            }

            this.btn_lock = true

            this.$http
                .q_hd('LuckDraw', hd_url, {
                    num: times,
                    type: type,
                    token: this.token,
                })
                .then((res) => {
                    if (res.code == 0) {
                        _this.pop_show = 0
                        _this.animate = true
                        _this.result_list = res.msg.map((item, index, arr) => {
                            item.rec_msg = ''
                            return item
                        })
                        _this.btn_lock = false
                        _this.getRecentLucky()
                        _this.getCounts()
                        _this.open_page = false
                        _this.first_buy = false
                    } else {
                        _this.pop_show = 0
                        if (res.jiubi) {
                            _this.pay_jiubi = res.jiubi
                            _this.btn_lock = false
                            _this.buy()
                        } else {
                            _this.mate_show(
                                '.buy-li-' + _this.buyBoxIndex + ' .btns',
                                res.error ? res.error : '购买失败，请稍后再试！',
                                -30
                            )
                            _this.btn_lock = false
                        }
                    }
                })
        },

        close_animate() {
            if (!_this.btn_lock) {
                _this.animate = false
                _this.pop_show = 0
            }
        },

        open_preview(item, type) {
            this.video_url = null
            this.pop_show = 2
            if (type == 1) {
                this.video_url = item.id ? item.id : null
                this.video_name = item.name ? item.name : null
            } else if (type == 2) {
                this.video_url = item.item_id ? item.item_id : null
                this.video_name = item.packet_name ? item.packet_name.split('*')[0] : null
            }
        },
        closePop() {
            this.pop_show = 0
            this.choose_id = 0
        },
        closePop2() {
            this.popup_show = 0
            this.choose_info.type = -1
            this.choose_info = null
            this.choose_index = -1
        },
        closePop3() {
            this.dialog_show = 0
        },
        open_pic(item) {
            this.pic_url = item.packet_id
            this.pic_name = item.name1 ? item.name1 : null
            this.pop_show = 3
        },
        compare_b(date1, date2) {
            if (date1 >= new Date(Date.parse(date2.replace(/-/g, '/')))) {
                return true
            } else {
                return false
            }
        },

        mate_show(element, text, offsetTop, offsetLeft = 5) {
            $('.mate-info').html(text)
            var width1 = $(element).width()
            var width = $('.mate-info').width() + 44
            var offWidth = (width1 - width) / 2
            var top = $('.content').offset().top
            var cssTop = $(element).offset().top - top + offsetTop
            var cssLeft = $(element).offset().left + offWidth + offsetLeft
            var css = {
                top: cssTop,
                left: cssLeft,
            }
            if (this.timer) {
                clearTimeout(this.timer)
            }
            $('.mate-info').show().css(css)
            this.timer = setTimeout(function () {
                $('.mate-info').hide().html('')
            }, 3000)
        },

        en_show() {
            $('.mate-info2').show()
        },
        le_hide() {
            $('.mate-info2').hide()
        },

        // 获取用户基础信息（是否为plus，以及plus的剩余天数）
        query_user_baseInfo() {
            $.ajax({
                url: 'https://users.09game.com/home/GetUserPub?user_id=' + this.token.split('-')[0],
                success: (res) => {
                    if (res.result == 0) {
                        var u = res.temp[0]
                        this.user_name = u.user_name
                        this.$storage.setUserId(u.user_id)
                        this.$storage.setUserName(u.user_name)
                    } else {
                        console.log('获取用户信息错误，错误码：' + res.result)
                    }
                },
            })
            this.$http.getAllUser(this.token).then((res) => {
                if (res.result == 0 && res.msg && res.msg.length > 0) {
                    this.account_list = res.msg
                    this.$storage.setAccountList(JSON.stringify(res.msg))
                } else {
                    this.account_list = []
                }
            })
        },

        buy() {
            let self = this
            if (this.btn_lock) {
                return false
            }
            this.btn_lock = 1
            this.$http
                .q_hd(
                    'PubPay',
                    'https://wx.pay.09game.com/WeChatPay/',
                    {
                        token: this.token,
                        total_fee: Number(this.pay_jiubi),
                    },
                    true
                )
                .then((res) => {
                    this.btn_lock = 0
                    if (res.code == 1) {
                        alert(res.msg)
                    } else if (res.code == 0) {
                        // console.log(res.data)
                        self.payData = res.data
                        if (typeof WeixinJSBridge == 'undefined') {
                            if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady, false)
                            } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', self.onBridgeReady)
                                document.attachEvent('onWeixinJSBridgeReady', self.onBridgeReady)
                            }
                        } else {
                            self.onBridgeReady()
                        }
                    }
                })
        },

        onBridgeReady() {
            let self = this
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest',
                {
                    appId: this.payData.appId, //公众号名称，由商户传入 ok
                    timeStamp: this.payData.timeStamp, //时间戳，自1970年以来的秒数 ok
                    nonceStr: this.payData.nonceStr, //随机串
                    package: this.payData.package,
                    signType: 'MD5', //微信签名方式
                    paySign: this.payData.paySign, //微信签名
                },
                function (res) {
                    if (res.err_msg == 'get_brand_wcpay_request:ok') {
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                        self.raffle_run(self.times, self.buy_type)
                    } else {
                        if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                            alert('取消支付！')
                        } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
                            alert('支付失败！')
                        } else {
                            alert(res.err_msg)
                        }
                    }
                }
            )
        },

        mate_show(element, text, offsetTop, offsetLeft = 10) {
            $('.mate-info').html(text)
            var width1 = $(element).width()
            var width = $('.mate-info').width() + 44
            var offWidth = (width1 - width) / 2
            var top = $('.content').offset().top
            var cssTop = $(element).offset().top - top + offsetTop
            var cssLeft = $(element).offset().left + offWidth + offsetLeft
            var css = {
                top: cssTop,
                left: cssLeft,
            }
            console.log(offWidth)
            if (this.timer) {
                clearTimeout(this.timer)
            }
            $('.mate-info').show().css(css)
            this.timer = setTimeout(function () {
                $('.mate-info').hide().html('')
            }, 3000)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/winter_lottery/index.scss';
</style>




// WEBPACK FOOTER //
// src/view/winter_lottery.vue